import { render } from "./ApiRequestBodySettings.vue?vue&type=template&id=01a63f2d&scoped=true&ts=true"
import script from "./ApiRequestBodySettings.vue?vue&type=script&lang=ts"
export * from "./ApiRequestBodySettings.vue?vue&type=script&lang=ts"

import "./ApiRequestBodySettings.vue?vue&type=style&index=0&id=01a63f2d&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01a63f2d"]])

export default __exports__